"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var TextField_1 = __importDefault(require("../TextField"));
var InputMask_1 = __importDefault(require("./InputMask"));
function PhoneField(props) {
    return (react_1.default.createElement(TextField_1.default, __assign({ InputProps: {
            inputComponent: InputMask_1.default
        } }, props)));
}
PhoneField.propTypes = {
    classes: prop_types_1.default.object
};
exports.default = PhoneField;
